import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '../../../../images/sendity_logo.svg';
import useIsMobile from '../../../../hooks/mobile';
import { Link } from 'react-router-dom';
import { simpleRegisterStep } from '../../../../staticData/staticData';
import sendityLogo from '../../../../themed/images/sendity-group.svg';
import './registerSimpleStep.css';
function RegisterSimpleStep({ activeStep }) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const [stepActive, setStepActive] = useState(0);

  useEffect(() => {
    if (isMobile) {
      setStepActive(activeStep + 1);
      return;
    }
    if (!isMobile || activeStep === 4) setStepActive(activeStep);
  }, [isMobile]);

  return (
    <>
      {isMobile ? (
        <section className="list_simple_register">
          <img src={sendityLogo} alt="logo sendity" />
          <h4 className="font-s c-greyone m-b-16">
            {t('Paso')}
            {` ${stepActive} `}
            {t('de')}
            {` ${simpleRegisterStep.length} `}
          </h4>
          <ul>
            {}
            {Array.from({ length: 5 }).map((step, index) => {
              let className = '';
              if (stepActive > index) className = 'completed';
              if (stepActive === index) className = 'active';
              if (index === simpleRegisterStep.length) return null;

              return <li key={index} className={className}></li>;
            })}
          </ul>
        </section>
      ) : (
        <div className="col-md-5 step_sec_left">
          <Link to="/login" className="sendity_logo">
            <img src={Logo} alt="" />
          </Link>
          <ul className="simple_register_desktop">
            <>
              {simpleRegisterStep.map((step, index) => {
                let className = 'font-s';
                if (stepActive > index) className = 'completed font-s';
                if (stepActive === index) className = 'active font-m';

                return (
                  <li key={index} className={className}>
                    {t(step.name)}
                  </li>
                );
              })}
            </>
          </ul>
        </div>
      )}
    </>
  );
}
export default RegisterSimpleStep;
